import { SalesInformation } from 'src/modules/shared/models/sales-information.model';

export class UpdateSalesInformation {
  static readonly type = '[Sales Information] Update';

  constructor(
    public salesInformation: SalesInformation
  ) {}
}
